import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  apiURL,
  formatDate,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceDeliveryStatusRoute = ({ routeId, customerNumber }) => {
  const { t } = useTranslation()

  const Fdata = new FormData()
  Fdata.append('delivery_status[customer_number]', customerNumber)
  Fdata.append('delivery_status[route]', routeId)
  const { data, loading, error } = useAxiosPartnerPortal(
    apiURL('delivery_status'),
    Fdata,
    'post'
  )

  return (
    <>
      {loading && <LoadingSpinner />}
      <a href="javascript:window.history.back()">
        <i className="fal fa-chevron-left"></i> AVIS
      </a>

      {data && (
        <div className="spa-block-full mt-2">
          <div data-spa-result-for="delivery_status">
            <table className="table table-condensed table-striped">
              <thead>
                <tr>
                  {t('generic.spa.results.delivery_status.detail_columns').map(
                    (col, index) => (
                      <th key={index}>{col}</th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {data.daten.map((row, index) => (
                  <tr key={index}>
                    <td>{formatDate(row.lieferdatum)}</td>
                    <td>{customerNumber}</td>
                    <td>{row.route}</td>
                    <td>{row.kfz}</td>
                    <td>{row.telefon}</td>
                    <td>{row.fahrer}</td>
                    <td>{row.aenderung}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}

export default SapServiceDeliveryStatusRoute
